<template>
  <CreateEditFinancialResourceModal
    v-if="showCreateEditFinancialResourceModal"
    :projectId="projectId"
    :financialResourceId="financialResourceIdSelected"
    @closeModal="closeModal"
  />
  <DeleteFinancialResourceModal
    v-if="showDeleteFinancialResourceModal"
    :projectId="projectId"
    :financialResourceId="financialResourceIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else>
    <div class="card">
      <div class="card-header d-flex align-items-center py-0">
        <h6 class="py-3 mb-0">Recursos Financeiros</h6>
        <div v-if="canEditProject" class="ms-auto">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            title="Cadastrar Recurso Financeiro"
            @click="createEditFinancialResource()"
          >
            Cadastrar Recurso
          </button>
        </div>
      </div>
      <div
        v-if="resources.resources.financialResources.length > 0"
        class="table-responsive table-scrollable"
      >
        <table class="table table-bordered">
          <thead class="table-primary">
            <tr>
              <th class="position-sticky top-0 fixed resource">
                Discriminação
              </th>
              <th
                v-for="projectBidder in bidders"
                :key="projectBidder.id"
                class="position-sticky top-0 text-center"
              >
                {{ projectBidder.bidderPartnerName }}
              </th>
              <th
                v-for="projectPartner in partners"
                :key="projectPartner.id"
                class="position-sticky top-0 text-center"
              >
                {{ projectPartner.bidderPartnerName }}
              </th>
              <th class="position-sticky top-0 text-center">Total</th>
              <th
                v-if="canEditProject"
                class="position-sticky top-0 text-center actions"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="financialResource in resources.resources
                .financialResources"
              :key="financialResource.id"
            >
              <td class="cursor-pointer" :title="financialResource.description">
                {{ financialResource.title }}
              </td>
              <td
                v-for="financialResourceBidder in financialResource.bidders"
                :key="financialResourceBidder.id"
                class="text-center"
              >
                {{ moneyToCurrencyBr(financialResourceBidder.value) }}
              </td>
              <td
                v-for="financialResourcePartner in financialResource.partners"
                :key="financialResourcePartner.id"
                class="text-center"
              >
                {{ moneyToCurrencyBr(financialResourcePartner.value) }}
              </td>
              <td class="text-center">
                <strong>
                  {{ moneyToCurrencyBr(financialResource.totals) }}
                </strong>
              </td>
              <td v-if="canEditProject">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-icon rounded-pill"
                  title="Excluir"
                  @click="deleteFinancialResource(financialResource.id)"
                >
                  <i class="ph-trash" />
                </button>
                <button
                  type="button"
                  class="btn btn-outline-warning btn-icon rounded-pill ms-2"
                  title="Editar"
                  @click="createEditFinancialResource(financialResource.id)"
                >
                  <i class="ph-pencil" />
                </button>
              </td>
            </tr>
            <tr class="table-primary">
              <td class="position-sticky bottom-0"><strong>Total</strong></td>
              <td
                v-for="bidder in resources.resources.totals.financialResources
                  .bidders"
                :key="bidder.name"
                class="position-sticky bottom-0 text-center"
              >
                <strong>{{ moneyToCurrencyBr(bidder.totals) }}</strong>
              </td>
              <td
                v-for="partner in resources.resources.totals.financialResources
                  .partners"
                :key="partner.name"
                class="position-sticky bottom-0 text-center"
              >
                <strong>{{ moneyToCurrencyBr(partner.totals) }}</strong>
              </td>
              <td class="position-sticky bottom-0 text-center">
                <strong>
                  {{
                    moneyToCurrencyBr(
                      resources.resources.totals.financialResources.total,
                    )
                  }}
                </strong>
              </td>
              <td
                v-if="canEditProject"
                class="position-sticky bottom-0 text-center"
              >
                -
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="card-body text-center">
        <p class="mb-0">
          Este sumário executivo não possui nenhum recurso financeiro aportado
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-header d-flex align-items-center py-0">
        <h6 class="py-3 mb-0">Recursos Financeiros Aportados</h6>
        <div v-if="canEditProject" class="ms-auto">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            title="Cadastrar Recurso Financeiro"
            @click="createEditFinancialResource()"
          >
            Cadastrar Recurso
          </button>
        </div>
      </div>
      <div
        v-if="resources.resources.financialResourcesContributed.length > 0"
        class="table-responsive table-scrollable"
      >
        <table class="table table-bordered">
          <thead class="table-primary">
            <tr>
              <th class="position-sticky top-0 fixed resource">
                Discriminação
              </th>
              <th
                v-for="projectBidder in bidders"
                :key="projectBidder.id"
                class="text-center"
              >
                {{ projectBidder.bidderPartnerName }}
              </th>
              <th
                v-for="projectPartner in partners"
                :key="projectPartner.id"
                class="text-center"
              >
                {{ projectPartner.bidderPartnerName }}
              </th>
              <th class="text-center">Total</th>
              <th v-if="canEditProject" class="text-center actions">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="financialResourceContributed in resources.resources
                .financialResourcesContributed"
              :key="financialResourceContributed.id"
            >
              <td
                class="cursor-pointer"
                :title="financialResourceContributed.description"
              >
                {{ financialResourceContributed.title }}
              </td>
              <td
                v-for="financialResourceContributedBidder in financialResourceContributed.bidders"
                :key="financialResourceContributedBidder.id"
                class="text-center"
              >
                {{
                  moneyToCurrencyBr(financialResourceContributedBidder.value)
                }}
              </td>
              <td
                v-for="financialResourceContributedPartner in financialResourceContributed.partners"
                :key="financialResourceContributedPartner.id"
                class="text-center"
              >
                {{
                  moneyToCurrencyBr(financialResourceContributedPartner.value)
                }}
              </td>
              <td class="text-center">
                <strong>
                  {{ moneyToCurrencyBr(financialResourceContributed.totals) }}
                </strong>
              </td>
              <td v-if="canEditProject">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-icon rounded-pill"
                  title="Excluir"
                  @click="
                    deleteFinancialResource(financialResourceContributed.id)
                  "
                >
                  <i class="ph-trash" />
                </button>
                <button
                  type="button"
                  class="btn btn-outline-warning btn-icon rounded-pill ms-2"
                  title="Editar"
                  @click="
                    createEditFinancialResource(financialResourceContributed.id)
                  "
                >
                  <i class="ph-pencil" />
                </button>
              </td>
            </tr>
            <tr class="table-primary">
              <td><strong class="position-sticky bottom-0">Total</strong></td>
              <td
                v-for="bidder in resources.resources.totals
                  .financialResourcesContributed.bidders"
                :key="bidder.name"
                class="position-sticky bottom-0 text-center"
              >
                <strong>{{ moneyToCurrencyBr(bidder.totals) }}</strong>
              </td>
              <td
                v-for="partner in resources.resources.totals
                  .financialResourcesContributed.partners"
                :key="partner.name"
                class="position-sticky bottom-0 text-center"
              >
                <strong>{{ moneyToCurrencyBr(partner.totals) }}</strong>
              </td>
              <td class="position-sticky bottom-0 text-center">
                <strong>
                  {{
                    moneyToCurrencyBr(
                      resources.resources.totals.financialResourcesContributed
                        .total,
                    )
                  }}
                </strong>
              </td>
              <td
                v-if="canEditProject"
                class="position-sticky bottom-0 text-center"
              >
                -
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="card-body text-center">
        <p class="mb-0">
          Este sumário executivo não possui nenhum recurso financeiro aportado
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CreateEditFinancialResourceModal from '@/components/projects/financialResources/CreateEditFinancialResourceModal.vue'
import DeleteFinancialResourceModal from '@/components/projects/financialResources/DeleteFinancialResourceModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'

export default {
  name: 'FinancialResourcesProject',

  components: {
    CreateEditFinancialResourceModal,
    DeleteFinancialResourceModal,
    LoadingData,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditFinancialResourceModal: false,
      showDeleteFinancialResourceModal: false,
      resources: {},
      bidders: [],
      partners: [],
      moneyToCurrencyBr,
    }
  },

  computed: {
    ...mapGetters(['projectSelected', 'canEditProject']),
  },

  methods: {
    async getFinancialResources() {
      try {
        this.resources = await this.$store.dispatch(
          'getProjectFinancialResources',
          this.projectId,
        )

        this.bidders = await this.$store.dispatch(
          'getProjectBidders',
          this.projectId,
        )

        this.partners = await this.$store.dispatch(
          'getProjectPartners',
          this.projectId,
        )

        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditFinancialResource(financialResourceId) {
      this.financialResourceIdSelected = financialResourceId || null
      this.showCreateEditFinancialResourceModal = true
    },

    deleteFinancialResource(financialResourceId) {
      this.financialResourceIdSelected = financialResourceId
      this.showDeleteFinancialResourceModal = true
    },

    closeModal(loadFinancialResources) {
      if (loadFinancialResources) {
        this.getFinancialResources()
      }
      this.showCreateEditFinancialResourceModal = false
      this.showDeleteFinancialResourceModal = false
    },
  },

  mounted() {
    this.getFinancialResources()
  },
}
</script>

<style scoped>
th.resource {
  min-width: 350px;
}
td,
th {
  padding: 0.4rem 0.8rem;
}
</style>
